export default "__VITE_ASSET__Ca3G5sd8__"